import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
  machines: [],
};

const getters = {
  getMachines (state) {
    return state.machines
  },
};

const mutations = {
  setMachines (state, payload) {
    state.machines = payload
  },
};

const actions = {

  fetchMachines ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/machine', {
        params: {
        }
      })
        .then(res => {
          commit('setMachines', res.data.data)
          console.log('fetchMachines - fetchMachines Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchUploadHistory ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/machine_attachment', {
        params: {
          limit: payload,
        }
      })
          .then(res => {
            // commit('setMachines', res.data.data)
            console.log('fetchUploadHistory - fetchUploadHistory Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  fetchSingleMachines ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/machine/'+payload, {
        params: {
        }
      })
          .then(res => {
            console.log('fetchSingleMachines - fetchSingleMachines Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  updateMachine ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/attendance/machine/'+payload.id, {
        id: payload.id,
        name: payload.name,
      })
        .then(res => {
          console.log('updateMachine - updateMachine Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },



  storeMachine ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/attendance/machine', {
        name: payload.name,
      })
        .then(res => {
          console.log('storeMachine - storeMachine Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },



  //
  // deleteShift ({commit, dispatch}, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
  //     axios.delete('/api/attendance/shift/'+payload.id)
  //       .then(res => {
  //         console.log('deleteShift - deleteShift Updated.');
  //         resolve(res.data);
  //       })
  //       .catch(error => {
  //         reject(error.response);
  //       })
  //   })
  // },


};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/attendance/machines.js